import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=3be345b5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be345b5"]])

export default __exports__